import { useMemo } from "react";
import { mapMenusToSidebarConfig } from "@gyandiksha/shared-ui/utils";
import { useGetMenusQuery } from "../app/services/menuAPI";

export const MODULE_IDS = Object.freeze({
    usk_placement: 1,
    usk_staff_attendance: 2,
    usk_student_attendance: 3,
    usk_student_skill_passport: 4,
    usk_sso: 5,
    usk_scholarship: 6,
});

export const resolveModuleId = (module) => {
    if (module === undefined || module === null) return undefined;
    if (typeof module === "number") return module;
    if (typeof module === "string") {
        if (!isNaN(Number(module)) && module.trim() !== "") {
            return Number(module);
        }
        return MODULE_IDS[module] ?? module;
    }
    return module;
};

export const useSidebarMenuConfig = (moduleOrOptions = {}, options = {}) => {
    let moduleId;
    let queryOptions = {};

    if (
        typeof moduleOrOptions === "number" ||
        (typeof moduleOrOptions === "string" && moduleOrOptions in MODULE_IDS) ||
        (typeof moduleOrOptions === "string" && !isNaN(Number(moduleOrOptions)) && moduleOrOptions.trim() !== "")
    ) {
        moduleId = resolveModuleId(moduleOrOptions);
        queryOptions = options;
    } else if (typeof moduleOrOptions === "object" && moduleOrOptions !== null) {
        const { moduleId: extractedModuleId, module, ...restOptions } = moduleOrOptions;
        moduleId = resolveModuleId(extractedModuleId ?? module);
        queryOptions = restOptions;
    } else if (typeof moduleOrOptions === "string") {
        moduleId = resolveModuleId(moduleOrOptions);
        queryOptions = options;
    } else {
        queryOptions = options;
    }

    const queryParams = moduleId !== undefined ? { moduleId } : undefined;
    const { data, isFetching, ...restQuery } = useGetMenusQuery(queryParams, queryOptions);

    const sidebarMenuConfig = useMemo(
        () => mapMenusToSidebarConfig(data?.data),
        [data]
    );

    return { sidebarMenuConfig, isFetching, data, ...restQuery };
};

